import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/react';
import { useRef } from 'react';
var pulseKeyframes = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\nto {\n  box-shadow: 0 0 0 7px rgba(0, 0, 0, 0);\n}\n"])));
var pulseStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-radius: 3px;\n  box-shadow: 0 0 0 0 ", ";\n  animation: ", " 1.45s cubic-bezier(0.5, 0, 0, 1) 3;\n"])), "var(--ds-background-discovery-bold, #5243AA)", pulseKeyframes);
var commonStyles = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline;\n"])));
export var Pulse = function Pulse(_ref) {
  var children = _ref.children,
    _ref$showPulse = _ref.showPulse,
    showPulse = _ref$showPulse === void 0 ? false : _ref$showPulse,
    onAnimationIteration = _ref.onAnimationIteration,
    onAnimationStart = _ref.onAnimationStart,
    testId = _ref.testId;
  // this ref is to persist the animation through rerenders
  var pulseStarted = useRef(false);
  if (showPulse) {
    pulseStarted.current = true;
  }
  var stopPropagation = function stopPropagation(e) {
    e.stopPropagation();
  };
  return jsx("div", {
    "data-testid": testId !== null && testId !== void 0 ? testId : 'discovery-pulse',
    css: [commonStyles, pulseStarted.current && pulseStyles],
    onAnimationIteration: onAnimationIteration,
    onAnimationStart: onAnimationStart
  }, jsx("span", {
    onAnimationIteration: stopPropagation,
    onAnimationStart: stopPropagation
  }, children));
};
export default Pulse;